import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "../../../core/helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/product/product-group`;

export const productGroupService = {
    listProductGroup: async function (loadOptions:any) {
        const params = processLoadOptions(loadOptions)
        return axios.get(`${GATEWAY_URL}/list-product-groups`,{
            params
        }).then((response) => {
            return response.data;
        });
    },
    lookupProductGroup: async function (loadOptions:any) {
        const params = processLoadOptions(loadOptions)
        return axios.get(`${GATEWAY_URL}/lookup-product-groups`,{
            params
        }).then((response) => {
            return response.data;
        });
    },
    getProductGroup: async function (id: any) {
        return axios.get(`${GATEWAY_URL}/get-product-group`, {
            params: { id }
        })
        .then((response) => {
            return response.data;
        });
    },
    createProductGroup: async function (params: any) {
        return axios.post(`${GATEWAY_URL}/create-product-group`, params)
        .then((response) => {
            return response.data;
        });
    },
    updateProductGroup: async function (keys:any, params: any) {
        return axios.put(`${GATEWAY_URL}/update-product-group`, params)
        .then((response) => {
            return response.data;
        });
    },
    deleteProductGroup: async function (key: any) {
        return axios.delete(`${GATEWAY_URL}/delete-product-group`, {
            params:{
                id:key
            }
        })
        .then((response) => {
            return response.data;
        });
    }
}
